"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FlashIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.037 6.612a.584.584 0 00-.537-.361H9.563l1.01-4.539a.584.584 0 00-1.016-.507L3.141 8.788a.583.583 0 00.443.962h3.273l-1.494 4.48a.583.583 0 00.263.682.584.584 0 00.533.045.582.582 0 00.19-.126l7.583-7.583a.583.583 0 00.105-.636z"
  })))
});
FlashIcon.displayName = 'FlashIcon';
var _default = exports.default = FlashIcon;